<template>
    <div>
        <el-container>
            <el-main>
                区域分析
                <el-tabs v-model="editableTabsValue" @tab-click="handleTabClick" type="border-card">
                  <el-tab-pane name="country" label="国家">
                    <el-table stripe :data="tableData" border size="mini">
                        <el-table-column align="center" prop="country" label="国家" width="100">
                        </el-table-column>
                        <el-table-column align="center" prop="amount" label="数量" width="110">
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane name="province" label="省份">
                    <el-table stripe :data="tableData" border size="mini">
                        <el-table-column align="center" prop="country" label="国家" width="100">
                        </el-table-column>
                        <el-table-column align="center" prop="province" label="省份" width="100">
                        </el-table-column>
                        <el-table-column align="center" prop="amount" label="数量" width="110">
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane name="city" label="城市">
                    <el-table stripe :data="tableData" border size="mini">
                        <el-table-column align="center" prop="country" label="国家" width="100">
                        </el-table-column>
                        <el-table-column align="center" prop="province" label="省份" width="100">
                        </el-table-column>
                        <el-table-column align="center" prop="city" label="城市" width="110">
                        </el-table-column>
                        <el-table-column align="center" prop="amount" label="数量" width="110">
                        </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
            </el-main>
        </el-container>
    </div>
</template>
<style>
</style>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
    name: 'userRegional',
    data() {
        return {
            tableData: [],
            editableTabsValue: "country"
        }
    },
    methods: {
        handleTabClick(tab, event) {
            this.getUserRegional(tab.name)
        },
        getUserRegional(scope) {
            let params = {
                scope: scope
            }
            this.$api.api.getUserRegional(params).then(
                resp => {
                    this.tableData = resp.data
                })
        }
    },
    mounted() {
        this.getUserRegional("country")
    },
    computed: {
        ...mapGetters([
          'hasPerm'
        ])
    },
    components: {}
}
</script>


// WEBPACK FOOTER //
// src/views/admin/analysis/user/list.vue